<div [ngClass]="colorScheme">
    <router-outlet></router-outlet>
</div>